import React, { createContext, useContext, useState } from 'react';
import { SllSection, SllLesson, SllModule } from '@api/graphql-codegen'
export type SelectionLevel = 'Lesson' | 'Content' | 'SectionContent' | undefined;

type EditLessonContextType = {
  lesson: SllLesson | undefined;
  setLesson: (lesson: SllLesson | undefined) => void;
  section: SllSection | undefined;
  setSection: (section: SllSection | undefined) => void;
  content: (SllModule & { originalModuleId?: string | null }) | undefined;
  setContent: (content: SllModule | undefined) => void;
  selectionLevel: SelectionLevel;
  setSelectionLevel: (level: SelectionLevel) => void;
  isPreparation: boolean | undefined;
  setIsPreparation: (isPreparation: boolean | undefined) => void;
};

const noop = () => void 0;

const defaultContext: EditLessonContextType = {
  lesson: undefined,
  setLesson: noop,
  section: undefined,
  setSection: noop,
  content: undefined,
  setContent: noop,
  selectionLevel: undefined,
  setSelectionLevel: noop,
  isPreparation: undefined,
  setIsPreparation: noop,
};

const EditLessonContext = createContext<EditLessonContextType>(defaultContext);

type Props = {
  children: React.ReactNode;
}
export const EditLessonProvider = (props: Props) => {
  const { children } = props;
  const [lesson, setLesson] = useState<SllLesson | undefined>();
  const [section, setSection] = useState<SllSection | undefined>();
  const [content, setContent] = useState<SllModule | undefined>();
  const [selectionLevel, setSelectionLevel] = useState<SelectionLevel>();
  const [isPreparation, setIsPreparation] = useState<boolean>();

  return (
    <EditLessonContext.Provider value={{
      lesson,
      setLesson,
      section,
      setSection,
      content,
      setContent,
      selectionLevel,
      setSelectionLevel,
      isPreparation,
      setIsPreparation
    }}>
      {children}
    </EditLessonContext.Provider>
  );
};

export const useEditLesson = () => useContext(EditLessonContext);
